export const delay = 800;
